import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Link} from 'react-router';
import classnames from 'classnames';
import Tooltip from 'components/Tooltip';
import WoffEmbeddedIcon from 'components/WoffEmbeddedIcon';
import RemoveIconModal from './RemoveIconModal';

export default createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
    workingSetIcon: ImmutablePropTypes.record.isRequired,
    onRemoveIcon: PropTypes.func.isRequired,
    showInList: PropTypes.bool,
  },

  mixins: [ImmutableRenderMixin],

  getDefaultProps() {
    return {
      showInList: false,
    };
  },

  getInitialState() {
    return {
      iconFocused: false,
      removeFocused: false,
      showConfirmation: false,
      isRemoving: false,
    };
  },

  getRemoveTooltip() {
    const {workingSetIcon} = this.props;

    let removeTooltip = null;

    if (workingSetIcon.custom) {
      removeTooltip = <Tooltip content="Delete Icon" icon="ficon-trash" />;
    } else {
      removeTooltip = <Tooltip content="Remove from Kit" icon="ficon-times" />;
    }

    return removeTooltip;
  },

  handleIconFocused() {
    this.setState({iconFocused: !this.state.iconFocused});
  },

  handleRemoveFocused() {
    this.setState({removeFocused: !this.state.removeFocused});
  },

  handleRemoved(event) {
    event.preventDefault();
    event.stopPropagation();

    const {workingSetIcon, onRemoveIcon} = this.props;

    if (workingSetIcon.custom && workingSetIcon.status === 'finished') {
      this.setState({showConfirmation: true});
    } else {
      this.setState({isRemoving: true});
      onRemoveIcon(workingSetIcon);
    }
  },

  handleConfirmation(event) {
    const {workingSetIcon, onRemoveIcon} = this.props;

    this.setState({
      showConfirmation: false,
      isRemoving: true,
    });

    onRemoveIcon(workingSetIcon);
  },

  handleClosed() {
    this.setState({showConfirmation: false});
  },

  renderFinished() {
    const {workingSetIcon, kitToken, showInList} = this.props;
    const linkClassName = classnames(
      'kit-icon',
      'asset',
      'asset-icon',
      'link-dashed-none',
      'asset-hover-emphasized',
      {'asset-uploaded': workingSetIcon.custom},
    );
    const {iconFocused, removeFocused, showConfirmation} = this.state;
    const removable = ~['finished', 'errored'].indexOf(workingSetIcon.status);
    const editTooltip = (iconFocused) ? <Tooltip content={`Edit ${workingSetIcon.name}`} icon="ficon-pencil" /> : null;
    const removeTooltip = (removeFocused && removable) ? this.getRemoveTooltip() : null;
    const indicator = (workingSetIcon.custom) ? <i className="ficon ficon-uploaded"></i> : null;
    const icon = (showInList) ? <WoffEmbeddedIcon woff={workingSetIcon.woff} iconSize={workingSetIcon.optimizedFor} /> : <WoffEmbeddedIcon woff={workingSetIcon.woff} />;

    let modal = null;

    if (workingSetIcon.custom) {
      modal = (
        <RemoveIconModal
          show={showConfirmation}
          kitToken={kitToken}
          workingSetIcon={workingSetIcon}
          onRemovedIcon={this.handleConfirmation}
          onClosed={this.handleClosed}
        />
      );
    }

    return (
      <Link to={`/kits/${kitToken}/icons/${workingSetIcon.id}`} className={linkClassName}>
        <div className="asset-inner" onMouseOver={this.handleIconFocused} onMouseOut={this.handleIconFocused}>
          {editTooltip}
          <div className="asset-preview">
            {icon}
          </div>

          <div className="asset-label icon-label text-sm">
            <span className="asset-label-copy">{workingSetIcon.name}</span> {indicator}
          </div>
        </div>

        <div className="asset-remove cursor-pointer link-dashed-none" onClick={this.handleRemoved} onMouseOver={this.handleRemoveFocused} onMouseOut={this.handleRemoveFocused}>
          {removeTooltip}
          <i className="ficon ficon-times"></i>
        </div>
        {modal}
      </Link>
    );
  },

  renderErrored() {
    const {workingSetIcon} = this.props;
    const {removeFocused} = this.state;
    const removable = ~['finished', 'errored'].indexOf(workingSetIcon.status);
    const removeTooltip = (removeFocused && removable) ? this.getRemoveTooltip() : null;

    return (
      <div className="asset asset-error asset-icon asset-icon-error br-a">
        <div className="asset-inner text-xs-center">
          <span className="block text-danger text-sm word-wrap p-xs-x-md m-xs-b-sm">Upload failed.</span>
        </div>

        <div className="asset-remove cursor-pointer link-dashed-none" onClick={this.handleRemoved} onMouseOver={this.handleRemoveFocused} onMouseOut={this.handleRemoveFocused}>
          {removeTooltip}
          <i className="ficon ficon-times"></i>
        </div>
      </div>
    );
  },

  renderRemoving() {
    return (
      <div className="asset asset-processing asset-icon asset-icon-processing br-a">
        <div className="asset-inner text-xs-center animated infinite pulseOpacity">
          <i className="ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-b-sm"></i>
          <span className="text-sm m-xs-x-sm">removing&hellip;</span>
        </div>
      </div>
    );
  },

  renderProcessing() {
    return (
      <div className="asset asset-processing asset-icon asset-icon-processing br-a">
        <div className="asset-inner text-xs-center animated infinite pulseOpacity">
          <i className="ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-b-sm"></i>
          <span className="text-sm m-xs-x-sm">adding&hellip;</span>
        </div>
      </div>
    );
  },

  render() {
    const {workingSetIcon} = this.props;
    const {isRemoving} = this.state;

    let value = null;

    switch (workingSetIcon.status) {
      case 'finished':
        value = this.renderFinished();
        break;
      case 'errored':
        value = this.renderErrored();
        break;
      default:
        value = this.renderProcessing();
    }

    if (isRemoving) {
      value = this.renderRemoving();
    }

    return value;
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/IconCard.js